import * as fromDatatype from '../datatype-library/index';

export interface  bl_crm_address_book_contact_record_link_RowInterface {
    guid:                        fromDatatype.GuidDataFieldInterface;
    address_book_guid:           fromDatatype.GuidDataFieldInterface;
    contact_record_hdr_guid:     fromDatatype.GuidDataFieldInterface;
    module_guid:                 fromDatatype.GuidDataFieldInterface;
    applet_guid:                 fromDatatype.GuidDataFieldInterface;
    link_type:                   fromDatatype.VarcharDatatypeInterface;
    created_date:                fromDatatype.TimestampTzDatatypeInterface;
    updated_date:                fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    status:                      fromDatatype.VarcharDatatypeInterface;
    revision:                    fromDatatype.GuidDataFieldInterface;
    namespace:                   fromDatatype.VarcharDatatypeInterface;
    acl_config:                  fromDatatype.JsonDatatypeInterface;
    acl_policy:                  fromDatatype.JsonDatatypeInterface;
    vrsn:                        fromDatatype.VarcharDatatypeInterface;

}

export class  bl_crm_address_book_contact_record_link_RowClass implements bl_crm_address_book_contact_record_link_RowInterface {
    guid:                        fromDatatype.GuidDataFieldInterface;
    address_book_guid:           fromDatatype.GuidDataFieldInterface;
    contact_record_hdr_guid:     fromDatatype.GuidDataFieldInterface;
    module_guid:                 fromDatatype.GuidDataFieldInterface;
    applet_guid:                 fromDatatype.GuidDataFieldInterface;
    link_type:                   fromDatatype.VarcharDatatypeInterface;
    created_date:                fromDatatype.TimestampTzDatatypeInterface;
    updated_date:                fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:     fromDatatype.GuidDataFieldInterface;
    status:                      fromDatatype.VarcharDatatypeInterface;
    revision:                    fromDatatype.GuidDataFieldInterface;
    namespace:                   fromDatatype.VarcharDatatypeInterface;
    acl_config:                  fromDatatype.JsonDatatypeInterface;
    acl_policy:                  fromDatatype.JsonDatatypeInterface;
    vrsn:                        fromDatatype.VarcharDatatypeInterface;
}
